<div class="d-flex flex-wrap gap-2 mb-1">
  <i
    *ngFor="let shift of shifts; trackBy: trackByShift"
    [ngClass]="shift.icon"
    class="fa-regular headline-16"
    [class.text-dark-gray]="candidateAvailability && !candidateAvailability[shift.control]"
    [ngbTooltip]="
      (candidateAvailability && candidateAvailability[shift.control]
        ? ('tooltip.willingnessShift' | translate)
        : ('tooltip.noWillingnessShift' | translate)) +
      ('shiftTimes.labelLong.' + shift.control | baseBusinessKey | translate)
    "
  ></i>
</div>
